// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { Vehicle } from "../models/Vehicle";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type HangarCreateData = Vehicle;

/** Params the client supplies at subscribe time. */
export type HangarCreateParams = Record<string, never>;

export class HangarCreateChannel extends Channel<HangarCreateParams, HangarCreateData> {
  static identifier = "HangarCreateChannel";
}
